// 零星计划池
import request from '@/utils/request'

export function apiScpDmQuantityPoolList (data) {
  return request({
    url: `/scp/scpDmQuantityPool/list`,
    method: 'post',
    data: data
  })
}

// 导出零星计划单池列表
export function apiScpDmQuantityPoolExport (data) {
  return request({
    url: '/scp/scpDmQuantityPool/export',
    method: 'post',
    data: data
  })
}

// 批量调整数量
export function apiScpAdjustQuantity (data) {
  return request({
    url: '/scp/scpDmQuantityPool/adjustQuantity',
    method: 'post',
    data: data
  })
}

// 批量调整发货日期
export function apiScpAdjustDeliveryDate (data) {
  return request({
    url: '/scp/scpDmQuantityPool/adjustDeliveryDate',
    method: 'post',
    data: data
  })
}

// 批量调整供应商
export function apiScpAdjustSupplier (data) {
  return request({
    url: '/scp/scpDmQuantityPool/adjustSupplier',
    method: 'post',
    data: data
  })
}

// 审核零星计划单池
export function apiScpDmQuantityPoolAudit (data) {
  return request({
    url: '/scp/scpDmQuantityPool/audit',
    method: 'post',
    data: data
  })
}
